import { render, staticRenderFns } from "./FacturasList.vue?vue&type=template&id=3636f486&scoped=true"
import script from "./FacturasList.vue?vue&type=script&lang=js"
export * from "./FacturasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636f486",
  null
  
)

export default component.exports